import { createContext, useContext } from 'react';
const SettingsChipToneContext = createContext('settings');
export const SettingsChipToneProvider = SettingsChipToneContext.Provider;
export const useSettingsChipTone = ()=>useContext(SettingsChipToneContext);
